$.fn.applyAutocomplete = function(options) {
    var self = this;
    this.apiUrl = 'https://api.pro6pp.nl/v1';
    this.pro6ppAuthKey = (options && options.pro6ppAuthKey) || "";
    this.postcode = this.find('input[data-autocomplete=postcode]');
    this.postcodeValidated = this.find('*[data-binding="postcode-validated"]');
    this.street = $('#address');	//this.find('input[data-binding=street]');
    this.streetValidated = this.find('*[data-binding="street-validated"]');
    this.streetnumber = $('#housenumber');	//this.find('input[data-binding=streetnumber]');
    this.streetnumberValidated = this.find('*[data-binding="streetnumber-validated"]');
    this.streetNL = this.find('input[data-binding=street-nl]');
    this.streetFR = this.find('input[data-binding=street-fr]');
    this.cityNL = $('#city');	//this.find('input[data-binding=city-nl]');
    this.cityFR = this.find('input[data-binding=city-fr]');
    this.municipalityNL = $('#county_id');	//this.find('input[data-binding=municipality-nl]');
    this.municipalityFR = this.find('input[data-binding=municipality-fr]');
    this.provinceNL = this.find('input[data-binding=province-nl]');
    this.provinceFR = this.find('input[data-binding=province-fr]');
    this.lat = this.find('input[data-binding=lat]');
    this.lng = this.find('input[data-binding=lng]');

    function invalidatePostcode() {
        if (self.postcode.data('geodata') &&
            self.postcode.val() !== self.postcode.data('geodata').labelNL &&
            self.postcode.val() !== self.postcode.data('geodata').labelFR) {
            self.postcode.removeData('geodata');
            self.postcodeValidated.css('display', 'none');
        }
    }

// console.log($('#country').val());
// console.log(this.postcode.val());
// console.log(this.streetnumber.val());

    this.streetnumber.blur(function() {
        // $('#postcode_status').closest('form').formValidation('updateStatus', 'postcode', 'NOT_VALIDATED', 'zipCode');
        self.postcode.blur();
    });

    // NL en DE
    this.postcode.blur(function() {
        // console.log('postcode blur');
        var data = {
            auth_key: self.pro6ppAuthKey,
            per_page: 10
        };
        var zipcode = $(this).val();

        //BE -> .autocomplete; Duitsland -> niet van toepassing
        if($('#country').val() === 'BE' || $('#country').val() === 'DE') {
            $('#county_id').val(-1); //Overige gemeenten
            $('#calc_price').data('county_id', -1);

            return false;
        } else {
            data.nl_sixpp = zipcode;
        }

        if (self.streetnumber.val() !== '') {
            data.streetnumber = self.streetnumber.val();
        }

        $.ajax({
            url: self.apiUrl + '/autocomplete',
            dataType: "jsonp",
            data: data,
            success: function( res ) {
                if (res.results.length) {
                    // var d = [];
                    res.results.forEach(function(result) {
                        // velden vullen
                        self.postcode.data('geodata', result);
                        self.postcode.val(result.nl_sixpp);
                        self.postcodeValidated.css('display', 'inline-block');

                        self.street.val(result.street);
                        self.cityNL.val(result.city);

                        var county_id = -1;
                        // eslint-disable-next-line no-unused-vars
                        var municipality = $('#country').val() === 'NL' ? result.municipality : result.municipality_nl;

                        //Bepaal county_id a.d.h.v. waarde uit de combo, default = -1;
                        county_id = -1; //Overige gemeente
                        $("select#county_id > option").each(function() {
                            if(result.municipality.toLowerCase() === this.text.toLowerCase()) {
                                county_id = this.value;
                            }
                        });

                        if(county_id !== 0) {
                            $('#county_id').val(county_id);
                            $('#calc_price').data('county_id', county_id);

                            $('#county_id option').removeAttr('selected');
                            $('#county_id option[value='+county_id+']').attr('selected', 'selected');

                            $('div.county div.current').html( $("#county_id option:selected").text() );
                        }
                    });
                } else {
                    invalidatePostcode();

                    if(res.status === 'error') {
                        // $('#postcode_status').closest('form').formValidation('updateStatus', 'postcode', 'INVALID', 'zipCode');
                        // $('#postcode_status').closest('form').formValidation('updateStatus', 'housenumber', 'INVALID', 'zipCode');
                    }
                }
            },
            error: function() { //jqXHR, textStatus, errorThrown
                invalidatePostcode();
            }
        });
    });

    // BELGIE
    this.postcode.autocomplete({
        source: function( request, response ) {
            var data = {
                auth_key: self.pro6ppAuthKey,
                per_page: 100
            };

            if($('#country').val() === 'BE') {
                // Determine whether to ask for city or postcode
                if (/^[0-9]/.test(request.term)) {
                    data.be_fourpp = request.term;
                } else {
                    data.be_city = request.term;
                }
            } else {
                //data.nl_sixpp = request.term;

                // voor NL blur gebruiken
                return false;
            }

            $.ajax({
                url: self.apiUrl + '/autocomplete',
                dataType: "jsonp",
                data: data,
                success: function( res ) {
                    if (res.results.length) {
                        var d = [];
                        res.results.forEach(function(result) {
                            if($('#country').val() == 'BE') {
                                var sl = !!data.be_city && VUGRON.Main.normalize(data.be_city);
                                if ((!sl) ||
                                    (VUGRON.Main.normalize(result.municipality_nl).startsWith(sl)) ||
                                    (VUGRON.Main.normalize(result.city_nl).startsWith(sl))) {
                                    result.labelNL = result.city_nl + ', ' + result.municipality_nl + ', ' + result.fourpp;

                                    var entryNL = {
                                        value: result.fourpp,
                                        label: result.labelNL,
                                        data: result};
                                    d.push(entryNL);
                                }

                                $('#county_id').val(-1);
                                $('#calc_price').data('county_id', -1);
                            }
                        });
                        response(d);
                    } else {
                        invalidatePostcode();
                        response();

                        if(res.status === 'error') {
                            // $('#postcode_status').closest('form').formValidation('updateStatus', 'postcode', 'INVALID', 'zipCode');
                            // $('#postcode_status').closest('form').formValidation('updateStatus', 'housenumber', 'INVALID', 'zipCode');
                        }
                    }
                },
                error: function() { //jqXHR, textStatus, errorThrown
                    invalidatePostcode();
                }
            });
        },
        minLength: 3,
        select: function( event, ui ) {
// console.log('select');
// console.log( ui.item );
            if (ui.item) {
                self.postcode.data('geodata', ui.item.data);
                self.postcode.val(ui.item.data.fourpp);
                self.postcodeValidated.css('display', 'inline-block');

                self.street.val('');

                self.cityNL.val(ui.item.data.city_nl);

                $('#county_id').val(-1);
                $('#calc_price').data('county_id', -1);

// self.streetnumber.focus();

                //self.municipalityNL.val(ui.item.data.municipality_nl);
                //self.municipalityFR.val(ui.item.data.municipality_fr);

                return false;
            }
        }
// }).blur(function() {
// 	if(self.postcode.data('geodata') === undefined) {
// 		// self.postcode.focus();
// 		$(this).data("uiAutocomplete").search($(this).val());
// 	}
    }).change(function() {
        if(typeof (self.postcode.data('geodata')) !== "undefined" && self.postcode.val() !== self.postcode.data('geodata').fourpp) {
            invalidatePostcode();
        }
    });

    function invalidateStreet() {
        if (self.street.data('geodata') &&
            self.street.val() !== self.street.data('geodata').labelNL &&
            self.street.val() !== self.street.data('geodata').labelFR) {
            self.street.removeData('geodata');
            self.streetValidated.css('display', 'none');
        }
    }

    this.street.autocomplete({
        source: function( request, response ) {
            if (!self.postcode.data('geodata')) {
                //console.log('First select a municipality');
                return;
            }
            if($('#country').val() === 'DE') {
                return false;
            }
            $.ajax({
                url: self.apiUrl + '/autocomplete',
                dataType: "jsonp",
                data: {
                    /*jshint camelcase: false */
                    auth_key: self.pro6ppAuthKey,
                    per_page: 10,
                    be_fourpp: self.postcode.data('geodata').fourpp,
                    /*jshint camelcase: true */
                    street: request.term
                },
                success: function( res ) {
                    if (res.results.length) {
                        var d = [];
                        res.results.forEach(function(result) {
                            /*jshint camelcase: false */
                            var sl = VUGRON.Main.normalize(request.term);
                            if (result.street_nl &&
                                VUGRON.Main.normalize(result.street_nl).startsWith(sl)) {
                                result.labelNL = result.street_nl;
                                var entryNL = {
                                    value: result.street_nl,
                                    label: result.labelNL,
                                    data: result};
                                d.push(entryNL);
                            }
                            if (result.street_fr &&
                                (VUGRON.Main.normalize(result.street_fr).startsWith(sl))) {
                                result.labelFR = result.street_fr;
                                var entryFR = {
                                    value: result.street_fr,
                                    /*jshint camelcase: true */
                                    label: result.labelFR,
                                    data: result};
                                d.push(entryFR);
                            }
                        });
                        response(d);
                    } else {
                        invalidateStreet();
                        response();
                    }
                },
                error: function() { //jqXHR, textStatus, errorThrown
                    //console.log('nothing');
                }
            });
        },
        minLength: 1,
        select: function( event, ui ) {
            if (ui.item) {
                self.street.val( ui.item.label );
                self.street.data('geodata', ui.item.data);
                self.streetValidated.css('display', 'inline-block');		// waarom werkt deze niert?
                /*jshint camelcase: false */
                self.streetNL.val(ui.item.data.street_nl);
                self.streetFR.val(ui.item.data.street_fr);
                /*jshint camelcase: true */
                self.lat.val(ui.item.data.lat);
                self.lng.val(ui.item.data.lng);
                return false;
            }
        }
    }).change(function() {
        invalidateStreet();
    });

    function invalidateStreetnumber() {
        if (self.streetnumber.data('geodata') &&
            self.streetnumber.val() !==
            self.streetnumber.data('geodata').label) {
            self.streetnumber.removeData('geodata');
            self.streetnumberValidated.css('display', 'none');
        }
    }

    this.streetnumber.autocomplete({
        source: function( request, response ) {
            if (self.street.val() === '') {
                //console.log('First select a street');
                return;
            }
            if($('#country').val() === 'DE') {
                return false;
            }
            var data= {
                /*jshint camelcase: false */
                auth_key: self.pro6ppAuthKey,
                street: self.street.val(),
                /*jshint camelcase: true */
                streetnumber: request.term
            };

            if($('#country').val() === 'BE') {
                data.be_fourpp = self.postcode.val();
            } else {
                data.nl_sixpp = self.postcode.val();
            }

            $.ajax({
                url: self.apiUrl + '/autocomplete',
                dataType: "jsonp",
                data: data,
                success: function( data ) {
                    if($('#country').val() === 'BE') {
                        if (typeof (data.results) !== "undefined" && data.results.length) {
                            var entry = {
                                value: data.results.streetnumber,
                                label:data.results.streetnumber,
                                data: data.results};
                            response([entry]);
                        } else {
                            invalidateStreetnumber();
                            response();
                        }
                    } else {
                        if(data.status === 'ok') {
                            self.street.val(data.results[0].street);
                            self.streetnumberValidated.css('display', 'inline-block');
                        } else {
                            // has-error
                        }
                    }
                },
                error: function() { //jqXHR, textStatus, errorThrown
                    //console.log('nothing');
                }
            });
        },
        minLength: 1,
        select: function( event, ui ) {
            if (ui.item) {
                self.streetnumber.val( ui.item.label );
                self.streetnumber.data('geodata', ui.item.value);
                self.streetnumberValidated.css('display', 'inline-block');
                self.lat.val(ui.item.data.lat);
                self.lng.val(ui.item.data.lng);
                return false;
            }
        }
    }).change(function() {
        invalidateStreetnumber();
    });
};
